// extracted by mini-css-extract-plugin
export default {"inner":"ContentWithTabs_inner__wLqin","avatar":"ContentWithTabs_avatar__jzkMX","tag":"ContentWithTabs_tag__KD38V","paragraph":"ContentWithTabs_paragraph__OXnaL"};